import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const MASTER_PATIENT_REQUEST = 'MASTER_PATIENT_REQUEST';
export const MASTER_PATIENT_SUCCESS = 'MASTER_PATIENT_SUCCESS';
export const MASTER_PATIENT_FAILURE = 'MASTER_PATIENT_FAILURE';

export const PATIENT_REQUEST = 'PATIENT_REQUEST';
export const PATIENT_SUCCESS = 'PATIENT_SUCCESS';
export const PATIENT_FAILURE = 'PATIENT_FAILURE';

export const CLAIMS_HISTORY_REQUEST = 'CLAIMS_HISTORY_REQUEST';
export const CLAIMS_HISTORY_SUCCESS = 'CLAIMS_HISTORY_SUCCESS';
export const CLAIMS_HISTORY_FAILURE = 'CLAIMS_HISTORY_FAILURE';

export const PATIENT_MEDICAL_CLAIMS_REQUEST = 'PATIENT_MEDICAL_CLAIMS_REQUEST';
export const PATIENT_MEDICAL_CLAIMS_SUCCESS = 'PATIENT_MEDICAL_CLAIMS_SUCCESS';
export const PATIENT_MEDICAL_CLAIMS_FAILURE = 'PATIENT_MEDICAL_CLAIMS_FAILURE';

export const PATIENT_RX_CLAIMS_REQUEST = 'PATIENT_RX_CLAIMS_REQUEST';
export const PATIENT_RX_CLAIMS_SUCCESS = 'PATIENT_RX_CLAIMS_SUCCESS';
export const PATIENT_RX_CLAIMS_FAILURE = 'PATIENT_RX_CLAIMS_FAILURE';

export const PATIENT_ENCOUNTERS_REQUEST = 'PATIENT_ENCOUNTERS_REQUEST';
export const PATIENT_ENCOUNTERS_SUCCESS = 'PATIENT_ENCOUNTERS_SUCCESS';
export const PATIENT_ENCOUNTERS_FAILURE = 'PATIENT_ENCOUNTERS_FAILURE';

export const PATIENT_HEALTH_PROFILE_REQUEST = 'PATIENT_HEALTH_PROFILE_REQUEST';
export const PATIENT_HEALTH_PROFILE_SUCCESS = 'PATIENT_HEALTH_PROFILE_SUCCESS';
export const PATIENT_HEALTH_PROFILE_FAILURE = 'PATIENT_HEALTH_PROFILE_FAILURE';

export const PATIENT_SURVEY_REQUEST = 'PATIENT_SURVEY_REQUEST';
export const PATIENT_SURVEY_SUCCESS = 'PATIENT_SURVEY_SUCCESS';
export const PATIENT_SURVEY_FAILURE = 'PATIENT_SURVEY_FAILURE';

export const PATIENTS_TYPEAHEAD_REQUEST = 'PATIENTS_TYPEAHEAD_REQUEST';
export const PATIENTS_TYPEAHEAD_SUCCESS = 'PATIENTS_TYPEAHEAD_SUCCESS';
export const PATIENTS_TYPEAHEAD_FAILURE = 'PATIENTS_TYPEAHEAD_FAILURE';

export const PATIENTS_ASSIGNMENTTYPES_REQUEST = 'PATIENTS_ASSIGNMENTTYPES_REQUEST';
export const PATIENTS_ASSIGNMENTTYPES_SUCCESS = 'PATIENTS_ASSIGNMENTTYPES_SUCCESS';
export const PATIENTS_ASSIGNMENTTYPES_FAILURE = 'PATIENTS_ASSIGNMENTTYPES_FAILURE';

export const PATIENTS_SPECIALPROGRAMS_REQUEST = 'PATIENTS_SPECIALPROGRAMS_REQUEST';
export const PATIENTS_SPECIALPROGRAMS_SUCCESS = 'PATIENTS_SPECIALPROGRAMS_SUCCESS';
export const PATIENTS_SPECIALPROGRAMS_FAILURE = 'PATIENTS_SPECIALPROGRAMS_FAILURE';

export const PATIENTSPECIALPROGRAMS_REQUEST = 'PATIENTSPECIALPROGRAMS_REQUEST';
export const PATIENTSPECIALPROGRAMS_SUCCESS = 'PATIENTSPECIALPROGRAMS_SUCCESS';
export const PATIENTSPECIALPROGRAMS_FAILURE = 'PATIENTSPECIALPROGRAMS_FAILURE';

export const PATIENTSPECIALPROGRAMS_ASSIGNED_REQUEST = 'PATIENTSPECIALPROGRAMS_ASSIGNED_REQUEST';
export const PATIENTSPECIALPROGRAMS_ASSIGNED_SUCCESS = 'PATIENTSPECIALPROGRAMS_ASSIGNED_SUCCESS';
export const PATIENTSPECIALPROGRAMS_ASSIGNED_FAILURE = 'PATIENTSPECIALPROGRAMS_ASSIGNED_FAILURE';

export const PATIENT_DOCUMENTS_REQUEST = 'PATIENT_DOCUMENTS_REQUEST';
export const PATIENT_DOCUMENTS_SUCCESS = 'PATIENT_DOCUMENTS_SUCCESS';
export const PATIENT_DOCUMENTS_FAILURE = 'PATIENT_DOCUMENTS_FAILURE';

export const PATIENT_DOCUMENT_UPLOAD_FILES_REQUEST = 'PATIENT_DOCUMENT_UPLOAD_FILES_REQUEST';
export const PATIENT_DOCUMENT_UPLOAD_FILES_SUCCESS = 'PATIENT_DOCUMENT_UPLOAD_FILES_SUCCESS';
export const PATIENT_DOCUMENT_UPLOAD_FILES_FAILURE = 'PATIENT_DOCUMENT_UPLOAD_FILES_FAILURE';

export function requestMasterPatients(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/search?${query}`,
      method: 'GET',
      types: ['MASTER_PATIENT_REQUEST', 'MASTER_PATIENT_SUCCESS', 'MASTER_PATIENT_FAILURE'],
    }
  };
}

export function requestPatient(masterPatientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/${masterPatientId}?${query}`,
      method: 'GET',
      types: ["PATIENT_REQUEST", "PATIENT_SUCCESS", "PATIENT_FAILURE"]
    }
  }
}

export function requestClaimsHistory(patientId, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/${patientId}/claims-history?${query}`,
      method: 'GET',
      types: [
        { type: "CLAIMS_HISTORY_REQUEST", meta: { patientId } },
        { type: "CLAIMS_HISTORY_SUCCESS", meta: { patientId } },
        { type: "CLAIMS_HISTORY_FAILURE", meta: { patientId } }
      ]
    }
  }
}

export function requestMedicalClaims(patientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/medical-claims/${patientId}?${query}`,
      method: 'GET',
      types: ["PATIENT_MEDICAL_CLAIMS_REQUEST", "PATIENT_MEDICAL_CLAIMS_SUCCESS", "PATIENT_MEDICAL_CLAIMS_FAILURE"]
    }
  }
}

export function requestRxClaims(patientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/rx-claims/${patientId}?${query}`,
      method: 'GET',
      types: ["PATIENT_RX_CLAIMS_REQUEST", "PATIENT_RX_CLAIMS_SUCCESS", "PATIENT_RX_CLAIMS_FAILURE"]
    }
  }
}

export function requestPatientEncounters(patientId, visitNoteId, params = {}) {
  const query = $.param({ ...params, exclude: visitNoteId });
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/encounters/${patientId}?${query}`,
      method: 'GET',
      types: [
        { type: 'PATIENT_ENCOUNTERS_REQUEST', meta: { patientId } },
        { type: 'PATIENT_ENCOUNTERS_SUCCESS', meta: { patientId } },
        'PATIENT_ENCOUNTERS_FAILURE',
      ],
    }
  }
}

export function requestHealthProfile(patientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/${patientId}/health-profile?${query}`,
      method: 'GET',
      types: [
        { type: "PATIENT_HEALTH_PROFILE_REQUEST", meta: { patientId } },
        { type: "PATIENT_HEALTH_PROFILE_SUCCESS", meta: { patientId } },
        { type: "PATIENT_HEALTH_PROFILE_FAILURE", meta: { patientId } }
      ]
    }
  }
}

export function requestSurveyData(patientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/survey-data/${patientId}?${query}`,
      method: 'GET',
      types: ["PATIENT_SURVEY_REQUEST", "PATIENT_SURVEY_SUCCESS", "PATIENT_SURVEY_FAILURE"]
    }
  }
}

export function requestPatientsTypeahead(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/typeahead?${query}`,
      method: 'GET',
      types: ['PATIENTS_TYPEAHEAD_REQUEST', 'PATIENTS_TYPEAHEAD_SUCCESS', 'PATIENTS_TYPEAHEAD_FAILURE']
    }
  };
}

export function requestInvitePatient(patientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/invite/${patientId}?${query}`,
      method: 'POST',
      types: ["PATIENT_INVITE_REQUEST", "PATIENT_INVITE_SUCCESS", "PATIENT_INVITE_FAILURE"]
    }
  }
}

export function requestAllPatientAssignmentTypes(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/cp/all-assignment-types?${query}`,
      method: 'GET',
      types: ['PATIENTS_ASSIGNMENTTYPES_REQUEST', 'PATIENTS_ASSIGNMENTTYPES_SUCCESS', 'PATIENTS_ASSIGNMENTTYPES_FAILURE']
    }
  };
}

export function requestAllSpecialPrograms(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/cp/all-special-programs?${query}`,
      method: 'GET',
      types: ['PATIENTS_SPECIALPROGRAMS_REQUEST', 'PATIENTS_SPECIALPROGRAMS_SUCCESS', 'PATIENTS_SPECIALPROGRAMS_FAILURE']
    }
  };
}

export function requestPatientSpecialProgramsByPatientId(patientId, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cp/${patientId}?${query}`,
      method: 'GET',
      types: ['PATIENTSPECIALPROGRAMS_REQUEST', 'PATIENTSPECIALPROGRAMS_SUCCESS', 'PATIENTSPECIALPROGRAMS_FAILURE']
    }
  }
}

export function requestAssignedPatientSpecialProgramsByPatientId(patientId, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cp/assigned/${patientId}?${query}`,
      method: 'GET',
      types: ['PATIENTSPECIALPROGRAMS_ASSIGNED_REQUEST', 'PATIENTSPECIALPROGRAMS_ASSIGNED_SUCCESS', 'PATIENTSPECIALPROGRAMS_ASSIGNED_FAILURE']
    }
  }
}

export function updatePatientToSpecialProgram(patientID, specialProgramID, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cp/add/${patientID}/to/${specialProgramID}?${query}`, 
      method: 'POST',
      types: ["PATIENTSPECIALPROGRAMS_UPDATE_REQUEST", "PATIENTSPECIALPROGRAMS_UPDATE_SUCCESS", "PATIENTSPECIALPROGRAMS_UPDATE_FAILURE"]
    }
  }
}

export function unassignPatientSpecialProgram(id, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/cp/unassign/${id}?${query}`,
      method: 'POST',
      types: ["PATIENTSPECIALPROGRAMS_UNASSIGN_REQUEST", "PATIENTSPECIALPROGRAMS_UNASSIGN_SUCCESS", "PATIENTSPECIALPROGRAMS_UNASSIGN_FAILURE"]
    }
  }
}

export function createPatient(patient, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients?${query}`,
      method: 'POST',
      body: JSON.stringify(patient),
      types: ["PATIENT_SAVE_REQUEST", "PATIENT_SAVE_SUCCESS", "PATIENT_SAVE_FAILURE"]
    }
  }
}

export function updatePatient(patient, patientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/${patientId}?${query}`,
      method: 'PUT',
      body: JSON.stringify(patient),
      types: ["PATIENT_SAVE_REQUEST", "PATIENT_SAVE_SUCCESS", "PATIENT_SAVE_FAILURE"]
    }
  }
}
export function inactivatePatient(patientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/inactivate/${patientId}?${query}`,
      method: 'PUT',
      types: ["PATIENT_INACTIVATE_REQUEST", "PATIENT_INACTIVATE_SUCCESS", "PATIENT_INACTIVATE_FAILURE"]
    }
  }
}

export function activatePatient(patientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/activate/${patientId}?${query}`,
      method: 'PUT',
      types: ["PATIENT_ACTIVATE_REQUEST", "PATIENT_ACTIVATE_SUCCESS", "PATIENT_ACTIVATE_FAILURE"]
    }
  }
}

export function requestPatientDocuments(patientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/${patientId}/documents/search?${query}`,
      method: 'GET',
      types: ["PATIENT_DOCUMENTS_REQUEST", "PATIENT_DOCUMENTS_SUCCESS", "PATIENT_DOCUMENTS_FAILURE"]
    }
  }
}

export function previewPatientDocumentFile(patientId, documentId, params, fileName) {
  const query = $.param(params);
  
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/${patientId}/documents/${documentId}/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'PATIENT_DOCUMENT_PREVIEW_FILE_REQUEST',
        {
          type: 'PATIENT_DOCUMENT_PREVIEW_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          },
        },
        'PATIENT_DOCUMENT_PREVIEW_FILE_FAILURE']
    }
  };
}

export function uploadPatientDocuments(patientId, params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('data.files', file));
  htmlFiles.forEach((file) => data.append('data.name', params.name));
  htmlFiles.forEach((file) => data.append('data.date', params.date));

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/${patientId}/documents?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['PATIENT_DOCUMENT_UPLOAD_FILES_REQUEST', 'PATIENT_DOCUMENT_UPLOAD_FILES_SUCCESS', 'PATIENT_DOCUMENT_UPLOAD_FILES_FAILURE']
    },
  };
}

export function deletePatientDocument(patientId, documentId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/${patientId}/documents/${documentId}?${query}`,
      method: 'DELETE',
      types: ["PATIENT_DOCUMENT_DELETE_REQUEST", "PATIENT_DOCUMENT_DELETE_SUCCESS", "PATIENT_DOCUMENT_DELETE_FAILURE"]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/patients/PatientsActions.js